import { useAppSelector } from 'hooks/reduxHooks';
import { hasActiveRequestsByType } from 'rdx/modules/activeRequests/slice';

export const useLoading = ({ watchRequests = [] }: { watchRequests?: string[] }) => {
  const hasActiveRequests = useAppSelector(hasActiveRequestsByType(watchRequests));
  return hasActiveRequests;
};
